export const RENDER_TYPE_SHOW_HIDE = 1
export const RENDER_TYPE_HTML = 2
export const RENDER_TYPE_FULL = 3
export const RENDER_TYPE_CONTENT = 4
export const RENDER_TYPE_TILE_GRID_GALLERY = 5
export const RENDER_TYPE_TILE_GRID_ROW = 6
export const RENDER_TYPE_FORM_BUTTON_BUTTON = 7
export const RENDER_TYPE_FORM_BUTTON_INPUT = 8
